import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { FaTrash } from "react-icons/fa";
import { useEffect, useState } from "react";
import { IProcessoCriarLoteLicenciamentos } from "../../Interfaces/IProcessoCriarLoteLicenciamentos";
import {
  Button,
  Container,
  ContainerInputPesquisa,
  DivAcoes,
  Header,
  Icon,
  InputPesquisa,
  InputWrapper,
  TextoHeader,
} from "./style";
import { ModalCertezaRemoverProcessoLote } from "../ModalCertezaRemoverProcessoLote";
import { ModalSucessoRemoverProcessoLote } from "../ModalSucessoRemoverProcessoLote";

interface IProps {
  clearRows: boolean;
  setRowsSelected: (ids: number[]) => void;
  processos: IProcessoCriarLoteLicenciamentos[];
  selectedRows: IProcessoCriarLoteLicenciamentos[];
  setProcessos: React.Dispatch<
    React.SetStateAction<IProcessoCriarLoteLicenciamentos[]>
  >;
  tela: string;
}
export function ListagemLoteLicenciamento({
  clearRows,
  setRowsSelected,
  processos,
  selectedRows,
  setProcessos,
  tela,
}: IProps) {
  const [showModalCertezaRemoverProcesso, setShowModalCertezaRemoverProcesso] =
    useState<boolean>(false);
  const [showModalSucessoRemoverProcesso, setShowModalSucessoRemoverProcesso] =
    useState<boolean>(false);

  const [dadosTabela, setDadosTabela] = useState<
    IProcessoCriarLoteLicenciamentos[]
  >([...processos]);
  const [textoBusca, setTextoBusca] = useState<string>("");
  const onChangePesquisa = () => {
    if (!textoBusca) {
      setDadosTabela([...processos]);
      return;
    }

    setDadosTabela(
      [...processos].filter((item) => {
        if (
          `${item.idProcesso}`.includes(textoBusca) ||
          (item.placa &&
            item.placa.replace("-", "").includes(textoBusca.replace("-", "")))
        ) {
          return true;
        }
        return false;
      }),
    );
  };

  useEffect(() => {
    onChangePesquisa();
  }, [textoBusca, processos]);

  const onRemoverDoLote = () => {
    setProcessos(
      [...processos].filter(
        (processo) =>
          !selectedRows.some((row) => row.idProcesso == processo.idProcesso),
      ),
    );
    setShowModalCertezaRemoverProcesso(false);
    setShowModalSucessoRemoverProcesso(true);
  };

  const columns: IColum<IProcessoCriarLoteLicenciamentos>[] = [
    {
      name: "ID Processo",
      selector: ({ idProcesso }: IProcessoCriarLoteLicenciamentos) =>
        idProcesso,
    },
    {
      name: "Placa",
      selector: ({ placa }: IProcessoCriarLoteLicenciamentos) => placa ?? "--",
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IProcessoCriarLoteLicenciamentos) =>
        renavam ?? "--",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IProcessoCriarLoteLicenciamentos) =>
        chassi ?? "--",
      width: "200px",
    },
    {
      name: "UF",
      selector: ({ uf }: IProcessoCriarLoteLicenciamentos) => uf ?? "--",
      width: "200px",
    },
    {
      name: "Serviço",
      selector: ({ servicoProcesso }: IProcessoCriarLoteLicenciamentos) =>
        servicoProcesso ?? "--",
      width: "250px",
    },
  ];

  return (
    <Container>
      <Header>
        <TextoHeader>Editar processos</TextoHeader>
        <DivAcoes>
          <Button
            variante="primary"
            outline
            onClick={() => {
              setShowModalCertezaRemoverProcesso(true);
            }}
            disabled={!selectedRows.length}
          >
            <FaTrash /> Remover do lote
          </Button>
        </DivAcoes>
      </Header>
      <hr />
      <ContainerInputPesquisa>
        <InputWrapper>
          <Icon />
          <InputPesquisa
            onChange={(e) => {
              setTextoBusca(e.target.value);
            }}
            placeholder="ID Processo ou placa"
          />
        </InputWrapper>
      </ContainerInputPesquisa>
      <Table
        key={`${tela}-${processos.length}`}
        keyField="idProcesso"
        columns={columns}
        data={dadosTabela}
        loading={false}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        headerFixo
        clearSelectedRows={clearRows}
      />
      <ModalCertezaRemoverProcessoLote
        show={showModalCertezaRemoverProcesso}
        handleClose={() => setShowModalCertezaRemoverProcesso(false)}
        onConfirm={onRemoverDoLote}
      />
      <ModalSucessoRemoverProcessoLote
        show={showModalSucessoRemoverProcesso}
        handleClose={() => setShowModalSucessoRemoverProcesso(false)}
      />
    </Container>
  );
}
